var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.ready)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"12","width":"2","color":"primary"}})],1):_vm._e(),( _vm.ready)?_c('v-avatar',{staticClass:"white--text caption",attrs:{"size":"24","color":"warning"}},[_c('span',[_vm._v(_vm._s(_vm.result.count))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }